<template>
    <div style="">
        <!-- Variant Protein -->

        <span style="width:100%;" v-for="(item, k) in this.$store.getters.getActiveBiomarker" v-bind:key="k">
            <NavBar_Variant v-bind:item="item"></NavBar_Variant>
        </span>

        <span style="width:100%;" v-for="(item, k) in this.$store.getters.getActiveBiomarker" v-bind:key="k">

                    <v-row align="center" justify="center" id="result-download">
                        <v-col cols="12" md="12" lg="12" xl="12" justify="center" align="center" style="">
                            <v-divider></v-divider>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <div v-if="this.$store.getters.isLoading" class="loading-spinner">
                              <div class="spinner"></div>
                              <div>Loading</div>
                            </div>
                        </v-col>
                    </v-row>

                    <div style="border:0px solid #f5f5f5;width:100%;">

                    <!--<v-divider></v-divider>-->
                    <span style="width:100%;" v-for="(item, k) in this.$store.getters.getActiveBiomarker" v-bind:key="k">
                        <v-row align="center" justify="center" id="result-download">
                            <v-col cols="12" md="12" lg="11" xl="11" justify="center" align="center" style="">
                                <v-divider></v-divider>
                                <div style="margin-left:20px;text-align:left;">
                                    <p style="font-size:16px;">
                                        Protein Features
                                        <!--<v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                        id="icon-protein-features" @click="showTooltip('icon-protein-features','protein-features-description-main')" />-->
                                    </p>
                                    <p style="font-size:12px; margin-top:5px;">
                                        Known variants of the selected variant position and the surrounding area,
                                        relative accessible surface area (RSA) and the secondary structure
                                    </p>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row style="">
                            <v-col cols="12" md="12" lg="12" xl="12" justify="center" align="center" style="">
                                <v-row style="margin:0;padding:0;">
                                    <v-col cols="11" md="11" lg="11" xl="11" justify="center" align="center" style="">
                                        <div id="protein_plot" style="">
                                        </div>
                                        <div style="">
                                            <div id="protein_legend" style="margin:0;">
                                            </div>
                                        </div>
                                    </v-col>
                                    <v-col cols="1" md="1" lg="1" xl="1" justify="center" align="center" style="border:0px solid red;">
                                        <v-row style="height: 25%;">
                                            <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                        id="icon-protein-features-1" @click="showTooltip('icon-protein-features-1','protein-features-desc-variants')" />
                                        </v-row>
                                        <v-row style="height: 11%;">
                                            <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                        id="icon-protein-features-2" @click="showTooltip('icon-protein-features-2','protein-features-desc-relasa')" />
                                        </v-row>
                                        <v-row style="height: 11%;">
                                            <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                id="icon-protein-calpha"
                                                @click="showTooltip('icon-protein-calpha','protein-features-desc-calpha')"
                                             />
                                        </v-row>
                                        <v-row style="height: 10%;">
                                            <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                id="icon-protein-domains"
                                                @click="showTooltip('icon-protein-domains','protein-features-desc-domains')"
                                             />
                                        </v-row>
                                        <v-row style="height: 48%;">
                                            <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                        id="icon-protein-features-3" @click="showTooltip('icon-protein-features-3','protein-features-desc-secstruc')" />
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </span>


                        <v-row>
                            <!-- Protein structure viewers -->
                            <v-col cols="12" md="12" lg="12" xl="12" style="text-align:left;border:0px solid red;">
                                <v-divider></v-divider>
                                <div style="" v-for="(item, k) in this.$store.getters.getActiveBiomarker" v-bind:key="k">
                                    <div style="margin-left:20px;text-align:left;margin-bottom:10px;">
                                        <p style="font-size:16px;">
                                            Protein Structure
                                            <span>
                                                ({{ item.UTA_Adapter.gene_name }},
                                                wild-type)
                                            </span>
                                            <!--<span v-if="this.active_transcript != undefined">
                                                <v-select v-if="this.active_transcript.pdb_ids != undefined"
                                                    v-model="this.active_protein"
                                                    :items="this.active_transcript.pdb_ids"
                                                    @update:modelValue="update_active_protein"
                                                    >
                                                </v-select>
                                            </span>-->
                                        </p>
                                    </div>
                                </div>

                                <v-row style="margin:0;padding:20px;" align="center" justify="left">
                                    <v-col cols="12" md="12" lg="4" xl="4" style="margin:0;padding:0;text-align:left;border:0px solid red;" align="center" justify="center">
                                        Protein features
                                        <v-table v-if="'protein_features' in item">
                                            <tr>
                                                <td>Secondary protein structure</td>
                                                <td>{{ item.protein_features.DSSP }}</td>
                                            </tr>
                                            <tr>
                                                <td>Relative accessible surface area (RSA)</td>
                                                <td>{{ item.protein_features.RSA }}</td>
                                            </tr>
                                            <tr>
                                                <td>Phi (&Phi;) angle</td>
                                                <td>{{ item.protein_features.Phi }}</td>
                                            </tr>
                                            <tr>
                                                <td>Psi (&Psi;) angle</td>
                                                <td>{{ item.protein_features.Psi }}</td>
                                            </tr>
                                        </v-table>
                                    </v-col>
                                    <v-col cols="12" md="12" lg="4" xl="4" align="left" justify="left" style="">
                                        <div class="content-box-toolbar-div">
                                                    <v-toolbar class="rounded-lg elevation-0" color="#f5f5f5" style="padding:0;text-align:left;height:35px;" density="compact">
                                                         <v-toolbar-title style="font-size:14px;font-weight:300;padding:0;margin:0;margin-left:10px;">
                                                               Domain
                                                         </v-toolbar-title>
                                                    </v-toolbar>
                                                </div>
                                        <v-card class="elevation-1 content-box" style="padding-left:10px;padding-right:10px;">
                                                    <div class="content-box-header-space"></div>
                                                    <v-table>
                                                        <tr>
                                                            <td>Interpro domain</td>
                                                            <td>{{ this.formatted_domain }}</td>
                                                        </tr>
                                                    </v-table>
                                        </v-card>

                                    </v-col>
                                </v-row>


                            </v-col>
                        </v-row>

                    </div>


                    <div style="height:40px;">
                    </div>
        </span>
        <v-row style="margin:0;padding:0;" align="center" justify="center">
                                    <v-col cols="12" md="12" lg="8" xl="8" style="margin:0;padding:0;text-align:left;border:0px solid red;" align="center" justify="center">
                                        <div style="text-align:center;border:3px solid #f5f5f5;height:840px;">
                                            <div style="padding-top:10px; padding-bottom:5px;">
                                                    Pathogenicity
                                                    <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                        id="icon-3dpatho" @click="showTooltip('icon-3dpatho','pathogenicity_desc')" />
                                            </div>
                                            <div style="text-align:center;border:3px solid #f5f5f5;height:600px;padding:20px;">
                                                <div ref="viewerContainer0" id="viewerContainer0" data-ui="false" class="viewer_3Dmoljs"
                                                    style="border:0px solid red;width:100%;height:700px;position:relative;"
                                                >
                                                </div>
                                                <v-btn @click="dialog_protein_patho = true" eager>
                                                    Show
                                                    <span style="width:10px;" eager></span>
                                                    <v-icon icon="mdi-arrow-expand" eager />
                                                </v-btn>
                                                <v-btn @click="download_pdb" eager>
                                                    Download PDB
                                                    <span style="width:10px;" eager></span>
                                                </v-btn>
                                            </div>
                                        </div>

                                        <v-dialog v-model="dialog_protein_patho" eager>
                                            <v-card style="width:100%;margin:auto;" eager>
                                                <v-btn @click="dialog_protein_patho = false" eager>Close</v-btn>
                                                <div style="height:20px;" eager></div>
                                                <!--<div id="chart-protein-patho" style="width:1000px;height:1200px;" eager></div>-->
                                                <div ref="viewerContainer4" id="viewerContainer4" data-ui="false" class="viewer_3Dmoljs"
                                                    style="border:0px solid red;width:100%;height:1200px;position:relative;" eager
                                                >
                                                </div>
                                            </v-card>
                                        </v-dialog>

                                    </v-col>
                                    <v-col cols="12" md="6" lg="4" xl="4" style="text-align:left;margin:0;padding:0;">
                                        <div style="text-align:center;border:3px solid #f5f5f5;height:420px;">
                                            <div style="padding-top:10px; padding-bottom:5px;">
                                                    Binding sites
                                                    <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                        id="icon-binding-sites" @click="showTooltip('icon-binding-sites','binding_site_desc')" />
                                            </div>
                                            <div style="text-align:center;border:3px solid #f5f5f5;height:420px;padding:20px;">
                                                <div ref="viewerContainer1" id="viewerContainer1" data-ui="true"
                                                    class="viewer_3Dmoljs"
                                                    style="border:0px solid red;width:600px;height:300px;position:relative;">
                                                </div>
                                                <v-btn @click="dialog_protein_binding = true" eager>
                                                    Show
                                                    <span style="width:10px;" eager></span>
                                                    <v-icon icon="mdi-arrow-expand" eager />
                                                </v-btn>
                                                <v-btn @click="download_pdb_bs" eager>
                                                    Download PDB
                                                    <span style="width:10px;" eager></span>
                                                </v-btn>
                                            </div>
                                        </div>

                                        <v-dialog v-model="dialog_protein_binding" eager>
                                            <v-card style="width:100%;margin:auto;" eager>
                                                <v-btn @click="dialog_protein_binding = false" eager>Close</v-btn>
                                                <div style="height:20px;" eager></div>
                                                <div ref="viewerContainer5" id="viewerContainer5" data-ui="false" class="viewer_3Dmoljs"
                                                    style="border:0px solid red;width:100%;height:1000px;position:relative;" eager
                                                ></div>
                                            </v-card>
                                        </v-dialog>

                                        <!--<div style="text-align:center;border:3px solid #f5f5f5;height:420px;">
                                            <div style="padding-top:10px; padding-bottom:5px;">
                                                    Altered protein
                                                    <v-icon size="1.5em" icon="mdi-tooltip-question" color="var(--dark-grey)"
                                                        id="icon-altered-protein" @click="showTooltip('icon-altered-protein','protein-altered')" />
                                            </div>
                                            <div ref="viewerContainer2" id="viewerContainer2" data-ui="true"
                                                class="viewer_3Dmoljs"
                                                style="border:0px solid red;width:600px;height:300px;position:relative;">
                                            </div>
                                            <v-btn @click="dialog_protein_mutated = true" eager>
                                                Show
                                                <span style="width:10px;" eager></span>
                                                <v-icon icon="mdi-arrow-expand" eager />
                                            </v-btn>
                                        </div>

                                        <v-dialog v-model="dialog_protein_mutated" eager>
                                            <v-card style="width:100%;margin:auto;" eager>
                                                <v-btn @click="dialog_protein_mutated = false" eager>Close</v-btn>
                                                <div style="height:20px;" eager></div>
                                                <div ref="viewerContainer6" id="viewerContainer6" data-ui="false" class="viewer_3Dmoljs"
                                                    style="border:0px solid red;width:100%;height:1000px;position:relative;" eager
                                                ></div>
                                            </v-card>
                                        </v-dialog>-->

                                    </v-col>
                                </v-row>

        <Loading v-model:active="isLoading" v-model="fullPage" :can-cancel="true" :is-full-page="fullPage" />



    </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import NavBar_Variant from '@/components/navbars/NavBar_Variant';
import active_variants from "@/methods/active_variants";
import { ref } from 'vue';

import Plotly from  '@/assets/js/plotly-latest.min.js';
import axios from 'axios';
import * as $3Dmol from '3dmol'
import '@/assets/js/3Dmol.ui-min.js'
import { mapGetters } from 'vuex'
import useTooltip from '@/methods/tooltip.js';
import variant_annotation from "@/methods/variant_annotation";


export default {
    name: 'VariantProtein',
    props: {
    },
    components: {
        Loading,
        NavBar_Variant,
    },
    setup() {
        return {
            seq: ref('AAAGAGGATAACACTAGCA'),
            annotations: ref([
                {
                    name: "promoter",
                    start: 9,
                    end: 12,
                    direction: 1
                },
                {
                    name: "promoter",
                    start: 3,
                    end: 6,
                    direction: 1
                },
                {
                    name: "promoter",
                    start: 0,
                    end: 3,
                    direction: 1
                }
            ])
        }
    },
    data: function () {
        return {
            isLoading: false,
            fullPage: true,
            show: false,
            protein_legend: {"data": [{"line": {"shape": "spline"}, "marker": {"color": "#2ca02c", "size": 3}, "mode": "lines+markers", "name": "lines+markers", "x": [0.0, 0.18181818181818182, 0.36363636363636365, 0.5454545454545454, 0.7272727272727273, 0.9090909090909092, 1.0909090909090908, 1.2727272727272727, 1.4545454545454546, 1.6363636363636365, 1.8181818181818183, 2.0], "y": [1, 2, 1, 0, 1, 2, 1, 0, 1, 2, 1, 0], "type": "scatter"}, {"line": {"shape": "spline"}, "marker": {"color": "#d62728", "size": 3}, "mode": "lines+markers", "name": "lines+markers", "x": [13.0, 13.181818181818182, 13.363636363636363, 13.545454545454545, 13.727272727272727, 13.90909090909091, 14.09090909090909, 14.272727272727273, 14.454545454545455, 14.636363636363637, 14.818181818181818, 15.0], "y": [1, 2, 1, 0, 1, 2, 1, 0, 1, 2, 1, 0], "type": "scatter"}, {"line": {"shape": "spline"}, "marker": {"color": "#e377c2", "size": 3}, "mode": "lines+markers", "name": "lines+markers", "x": [22.0, 22.181818181818183, 22.363636363636363, 22.545454545454547, 22.727272727272727, 22.90909090909091, 23.09090909090909, 23.272727272727273, 23.454545454545453, 23.636363636363637, 23.81818181818182, 24.0], "y": [1, 2, 1, 0, 1, 2, 1, 0, 1, 2, 1, 0], "type": "scatter"}, {"line": {"shape": "spline"}, "marker": {"color": "#8c564b", "size": 3}, "mode": "lines+markers", "name": "lines+markers", "x": [30.0, 30.181818181818183, 30.363636363636363, 30.545454545454547, 30.727272727272727, 30.90909090909091, 31.09090909090909, 31.272727272727273, 31.454545454545453, 31.636363636363637, 31.81818181818182, 32.0], "y": [1, 2, 1, 0, 1, 2, 1, 0, 1, 2, 1, 0], "type": "scatter"}, {"fill": "toself", "fillcolor": "#1f77b4", "hoverinfo": "skip", "line": {"color": "#1f77b4"}, "mode": "lines", "opacity": 1, "x": [45, 44, 44, 45], "y": [1, 1.8, 0.19999999999999996, 1], "type": "scatter"}, {"hoverinfo": "skip", "line": {"color": "#1f77b4", "width": 25}, "mode": "lines", "x": [43, 44], "y": [1, 1], "type": "scatter"}, {"hoverinfo": "text", "marker": {"color": "#1f77b4", "size": 3}, "text": ["B: Isolated beta-bridge residue<br>position: 43<br>"], "x": [43, 44, 45], "y": [1, 1, 1], "type": "scatter"}, {"fill": "toself", "fillcolor": "#9467bd", "hoverinfo": "skip", "line": {"color": "#9467bd"}, "mode": "lines", "opacity": 1, "x": [63, 62, 62, 63], "y": [1, 1.8, 0.19999999999999996, 1], "type": "scatter"}, {"hoverinfo": "skip", "line": {"color": "#9467bd", "width": 25}, "mode": "lines", "x": [61, 62], "y": [1, 1], "type": "scatter"}, {"hoverinfo": "text", "marker": {"color": "#9467bd", "size": 3}, "text": ["E: Strand<br>position: 61<br>"], "x": [61, 62, 63], "y": [1, 1, 1], "type": "scatter"}, {"hoverinfo": "text", "marker": {"color": "black", "size": 3}, "mode": "lines+markers", "text": ["-: None<br>position: 69<br>"], "x": [69, 70, 71], "y": [1, 1, 1], "type": "scatter"}, {"hoverinfo": "text", "marker": {"color": "#ff7f0e ", "size": 3}, "mode": "lines+markers", "text": ["S: Bend<br>position: 77<br>"], "x": [77, 78, 79], "y": [1, 1, 1], "type": "scatter"}, {"hoverinfo": "text", "marker": {"color": "#17becf", "size": 3}, "mode": "lines+markers", "text": ["T: Turn<br>position: 85<br>"], "x": [85, 86, 87], "y": [1, 1, 1], "type": "scatter"}], "layout": {"template": {"data": {"barpolar": [{"marker": {"line": {"color": "white", "width": 0.5}, "pattern": {"fillmode": "overlay", "size": 10, "solidity": 0.2}}, "type": "barpolar"}], "bar": [{"error_x": {"color": "#2a3f5f"}, "error_y": {"color": "#2a3f5f"}, "marker": {"line": {"color": "white", "width": 0.5}, "pattern": {"fillmode": "overlay", "size": 10, "solidity": 0.2}}, "type": "bar"}], "carpet": [{"aaxis": {"endlinecolor": "#2a3f5f", "gridcolor": "#C8D4E3", "linecolor": "#C8D4E3", "minorgridcolor": "#C8D4E3", "startlinecolor": "#2a3f5f"}, "baxis": {"endlinecolor": "#2a3f5f", "gridcolor": "#C8D4E3", "linecolor": "#C8D4E3", "minorgridcolor": "#C8D4E3", "startlinecolor": "#2a3f5f"}, "type": "carpet"}], "choropleth": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "type": "choropleth"}], "contourcarpet": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "type": "contourcarpet"}], "contour": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "colorscale": [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]], "type": "contour"}], "heatmapgl": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "colorscale": [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]], "type": "heatmapgl"}], "heatmap": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "colorscale": [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]], "type": "heatmap"}], "histogram2dcontour": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "colorscale": [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]], "type": "histogram2dcontour"}], "histogram2d": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "colorscale": [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]], "type": "histogram2d"}], "histogram": [{"marker": {"pattern": {"fillmode": "overlay", "size": 10, "solidity": 0.2}}, "type": "histogram"}], "mesh3d": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "type": "mesh3d"}], "parcoords": [{"line": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "parcoords"}], "pie": [{"automargin": true, "type": "pie"}], "scatter3d": [{"line": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "marker": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "scatter3d"}], "scattercarpet": [{"marker": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "scattercarpet"}], "scattergeo": [{"marker": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "scattergeo"}], "scattergl": [{"marker": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "scattergl"}], "scattermapbox": [{"marker": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "scattermapbox"}], "scatterpolargl": [{"marker": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "scatterpolargl"}], "scatterpolar": [{"marker": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "scatterpolar"}], "scatter": [{"fillpattern": {"fillmode": "overlay", "size": 10, "solidity": 0.2}, "type": "scatter"}], "scatterternary": [{"marker": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "type": "scatterternary"}], "surface": [{"colorbar": {"outlinewidth": 0, "ticks": ""}, "colorscale": [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]], "type": "surface"}], "table": [{"cells": {"fill": {"color": "#EBF0F8"}, "line": {"color": "white"}}, "header": {"fill": {"color": "#C8D4E3"}, "line": {"color": "white"}}, "type": "table"}]}, "layout": {"annotationdefaults": {"arrowcolor": "#2a3f5f", "arrowhead": 0, "arrowwidth": 1}, "autotypenumbers": "strict", "coloraxis": {"colorbar": {"outlinewidth": 0, "ticks": ""}}, "colorscale": {"diverging": [[0, "#8e0152"], [0.1, "#c51b7d"], [0.2, "#de77ae"], [0.3, "#f1b6da"], [0.4, "#fde0ef"], [0.5, "#f7f7f7"], [0.6, "#e6f5d0"], [0.7, "#b8e186"], [0.8, "#7fbc41"], [0.9, "#4d9221"], [1, "#276419"]], "sequential": [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]], "sequentialminus": [[0.0, "#0d0887"], [0.1111111111111111, "#46039f"], [0.2222222222222222, "#7201a8"], [0.3333333333333333, "#9c179e"], [0.4444444444444444, "#bd3786"], [0.5555555555555556, "#d8576b"], [0.6666666666666666, "#ed7953"], [0.7777777777777778, "#fb9f3a"], [0.8888888888888888, "#fdca26"], [1.0, "#f0f921"]]}, "colorway": ["#636efa", "#EF553B", "#00cc96", "#ab63fa", "#FFA15A", "#19d3f3", "#FF6692", "#B6E880", "#FF97FF", "#FECB52"], "font": {"color": "#2a3f5f"}, "geo": {"bgcolor": "white", "lakecolor": "white", "landcolor": "white", "showlakes": true, "showland": true, "subunitcolor": "#C8D4E3"}, "hoverlabel": {"align": "left"}, "hovermode": "closest", "mapbox": {"style": "light"}, "paper_bgcolor": "white", "plot_bgcolor": "white", "polar": {"angularaxis": {"gridcolor": "#EBF0F8", "linecolor": "#EBF0F8", "ticks": ""}, "bgcolor": "white", "radialaxis": {"gridcolor": "#EBF0F8", "linecolor": "#EBF0F8", "ticks": ""}}, "scene": {"xaxis": {"backgroundcolor": "white", "gridcolor": "#DFE8F3", "gridwidth": 2, "linecolor": "#EBF0F8", "showbackground": true, "ticks": "", "zerolinecolor": "#EBF0F8"}, "yaxis": {"backgroundcolor": "white", "gridcolor": "#DFE8F3", "gridwidth": 2, "linecolor": "#EBF0F8", "showbackground": true, "ticks": "", "zerolinecolor": "#EBF0F8"}, "zaxis": {"backgroundcolor": "white", "gridcolor": "#DFE8F3", "gridwidth": 2, "linecolor": "#EBF0F8", "showbackground": true, "ticks": "", "zerolinecolor": "#EBF0F8"}}, "shapedefaults": {"line": {"color": "#2a3f5f"}}, "ternary": {"aaxis": {"gridcolor": "#DFE8F3", "linecolor": "#A2B1C6", "ticks": ""}, "baxis": {"gridcolor": "#DFE8F3", "linecolor": "#A2B1C6", "ticks": ""}, "bgcolor": "white", "caxis": {"gridcolor": "#DFE8F3", "linecolor": "#A2B1C6", "ticks": ""}}, "title": {"x": 0.05}, "xaxis": {"automargin": true, "gridcolor": "#EBF0F8", "linecolor": "#EBF0F8", "ticks": "", "title": {"standoff": 15}, "zerolinecolor": "#EBF0F8", "zerolinewidth": 2}, "yaxis": {"automargin": true, "gridcolor": "#EBF0F8", "linecolor": "#EBF0F8", "ticks": "", "title": {"standoff": 15}, "zerolinecolor": "#EBF0F8", "zerolinewidth": 2}}}, "annotations": [{"font": {"size": 15}, "showarrow": false, "text": "H: Alpha helix (4-12)", "x": 2.5, "xanchor": "left", "y": 1}, {"font": {"size": 15}, "showarrow": false, "text": "G: 3-10 helix", "x": 15.5, "xanchor": "left", "y": 1}, {"font": {"size": 15}, "showarrow": false, "text": "I: Pi helix", "x": 24.5, "xanchor": "left", "y": 1}, {"font": {"size": 15}, "showarrow": false, "text": "P: Poly-Proline helix", "x": 32.5, "xanchor": "left", "y": 1}, {"font": {"size": 15}, "showarrow": false, "text": "B: Isolated beta-bridge residue", "x": 45.5, "xanchor": "left", "y": 1}, {"font": {"size": 15}, "showarrow": false, "text": "E: Strand", "x": 63.5, "xanchor": "left", "y": 1}, {"font": {"size": 15}, "showarrow": false, "text": "-: None", "x": 71.5, "xanchor": "left", "y": 1}, {"font": {"size": 15}, "showarrow": false, "text": "S: Bend", "x": 79.5, "xanchor": "left", "y": 1}, {"font": {"size": 15}, "showarrow": false, "text": "T: Turn", "x": 87.5, "xanchor": "left", "y": 1}], "hovermode": false, "showlegend": false, "title": {"text": "Legend of secondary structures"}, "yaxis": {"visible": true, "showticklabels": false, "showline": true, "linewidth": 3, "linecolor": "black", "mirror": true, "showgrid": false, "zeroline": false}, "xaxis": {"visible": true, "showticklabels": false, "range": [-0.5, 93], "showline": true, "linewidth": 3, "linecolor": "black", "mirror": true, "showgrid": false, "zeroline": false}, "height": 110, "margin": {"t": 30, "b": 5, "pad": 0}}},
            pmol: '',
            active_transcript: {},
            active_protein: '',
            mutated_patho : 'grey',
            dialog_protein_patho: false,
            dialog_protein_binding: false,
            dialog_protein_mutated: false,
            prot_seq_cols: 5,
            pdb_data: '',
            pdb_bs_data: '',
            pid: '',
        }
    },
      errorCaptured(err, vm, info) {
    console.log('Error Captured:', err);
    return false;  // Prevents the error from propagating further
  },
    methods: {
        download_pdb() {
          // Create a blob from the content
          const blob = new Blob([this.pdb_data], { type: 'text/plain' });

          // Create a temporary URL for the blob
          const url = URL.createObjectURL(blob);

          // Create a temporary <a> element to trigger the download
          const link = document.createElement('a');
          link.href = url;

          // Set the file name (you can customize the file name here)
          link.download = this.pid + '_structure.pdb';

          // Append the link to the body (required for some browsers)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by revoking the object URL and removing the temporary link
          URL.revokeObjectURL(url);
          document.body.removeChild(link);
        },
        download_pdb_bs() {
          // Create a blob from the content
          const blob = new Blob([this.pdb_bs_data], { type: 'text/plain' });

          // Create a temporary URL for the blob
          const url = URL.createObjectURL(blob);

          // Create a temporary <a> element to trigger the download
          const link = document.createElement('a');
          link.href = url;

          // Set the file name (you can customize the file name here)
          link.download = this.pid + '_structure_binding_sites.pdb';

          // Append the link to the body (required for some browsers)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by revoking the object URL and removing the temporary link
          URL.revokeObjectURL(url);
          document.body.removeChild(link);
        },
        defineColumns() {
          const width = window.innerWidth;

          // Define number of columns based on screen width
          if (width < 600) {
            this.prot_seq_cols = 1; // Mobile devices
          } else if (width >= 600 && width < 900) {
            this.prot_seq_cols = 2; // Small tablets
          } else if (width >= 900 && width < 1200) {
            this.prot_seq_cols = 3; // Tablets
          } else if (width >= 1200 && width < 1600) {
            this.prot_seq_cols = 4; // Medium screens
          } else {
            this.prot_seq_cols = 5; // Large screens
          }
        },
        showTooltip (element_id, tooltip_id, tooltip_title = undefined) {
            useTooltip.fireTooltipEvent(element_id, tooltip_id, tooltip_title);
        },
        async copySequence() {
          let cpText = ">Seq"+ this.active_transcript.transcript_id + " [organism=Homo sapiens]\n" + this.active_transcript.protein_sequence
          await navigator.clipboard.writeText(cpText);
        },
        format_protein_sequence(pseq,prot_location,alt) {
                    let mark_pos = false
                    if ("tag" in this.active_transcript) {
                        if (this.active_transcript.tag.includes("MANE_Select")) {
                            mark_pos = true
                        }
                    }

                    const prot_seq_length = 5

                    let pseq_arr = pseq.match(/.{1,10}/g);

                    let row_c = 0
                    let protloc = 0
                    let color='#e4eff2'
                    let arr_str = ''
                    let ic = 0
                    let rows = 0
                    let aa_section= 0
                    let pseq_str = ''
                    //let isVariant = false
                    let aa = ""
                    //alert(JSON.stringify(this.activeBiomarker))

                    pseq_str += '<div style="width:90%;margin:auto;padding:20px;background-color:#e4eff2;"><div style="margin:20px;">Seq'+this.active_transcript.transcript_id+' [organism=Homo sapiens] </div>'

                    pseq_str += '<table style="white-space: pre-wrap;font-family:monospace;margin:20px;width:600px;"><tr>'
                    //pseq_str += '<v-row style="width:100%;">'
                    //pseq_str += '<v-col cols="6" md="6" lg="2" xl="2" style="text-align:center;">'

                    for (let i = 0;i< pseq_arr.length; i += 1) {
                        aa_section = aa_section + 10

                        //pseq_str += '<v-col cols="6" md="6" lg="2" xl="2" style="border:1px solid red;text-align:center;">'
                        pseq_str += '<td style="white-space: pre-wrap;font-family:monospace;padding-right:40px;margin-left:10px;margin-right:30px;">'

                        pseq_str += '<table><tr><td style="text-align:right;color:#6a6a6a;">' + aa_section + '</td></tr><tr><td>'

                        arr_str = pseq_arr[i]
                        //pseq_str += pseq_arr[i]
                        for (let j =0;j<arr_str.length; j++) {
                            protloc++;
                            aa = arr_str[j]
                            if ((protloc) > (parseInt(prot_location)-10) ) {
                                //color='#a1cce4'
                                color='#e4eff2'
                                aa = arr_str[j]
                            }
                            if ((protloc) > (parseInt(prot_location)+10)) {
                                color='#e4eff2'
                                aa = arr_str[j]
                            }
                            if (protloc == parseInt(prot_location)) {
                                if (mark_pos == true) {
                                    color='red'
                                    //isVariant = true
                                    //aa = arr_str[j]
                                    aa = alt
                                }
                            }
                            pseq_str += '<span style="padding:2px;margin-left:2px; margin-right:2px;background-color:'+color+';">' + aa + '</span>'

                        }

                        pseq_str += '</td></tr></table>'
                        pseq_str +='</td>'
                        //pseq_str += '</v-col>'

                        row_c += 1
                        //protloc += 6
                        if (row_c == this.prot_seq_cols) {
                            rows++
                            pseq_str += '</tr><tr>'
                            //pseq_str += '</v-col><v-col>'
                            //pseq_str += '</v-row><v-row>'
                            //pseq_str += '<td>' + aa_section + '</td>'
                            row_c = 0
                        }
                    }
                    pseq_str += '</tr></table></div>'
                    //pseq_str += '</v-row>'
                    pseq_str +='</div>'
                    this.pseq = pseq_str
                    //alert(pseq_str)
                    return pseq_str
            },
         async loadProteinData() {
            let url=this.$store.getters.getPathVariable('methods_generate_plot')
            let formData = new FormData();
            let variant_protein_data = {}

            variant_protein_data["UTA_Adapter"] = {}
            variant_protein_data["UTA_Adapter"]["gene_name"] = this.$store.getters.getActiveBiomarker[Object.keys(this.$store.getters.getActiveBiomarker)[0]]["UTA_Adapter"]["gene_name"]
            variant_protein_data["UTA_Adapter"]["variant_exchange"] = this.$store.getters.getActiveBiomarker[Object.keys(this.$store.getters.getActiveBiomarker)[0]]["UTA_Adapter"]["variant_exchange"]
            formData.append("variant_data", JSON.stringify(variant_protein_data) )
            formData.append("plot", "protein-data");

            await axios.post(url, formData, {
              headers: {
                "Content-Type": "text/html"
              }
            }).then((response) => {
                var response = response.data
                if (response.length > 0) {
                    try {
                        var graphJSON = response[0]["data"]["plot_json"]
                        //alert(JSON.stringify(graphJSON))

                        Plotly.plot('protein_plot',graphJSON,graphJSON);
                        Plotly.plot('protein_legend',this.protein_legend,this.protein_legend)
                        this.$store.dispatch('setProcessState', [  "load-radar-0-thumb","" ] )
                    } catch (error) {
                        console.log(error)
                    }
                } else{
                    console.log("Error: Could not retrieve protein feature data")
                }
            })
        },
        getGencodeAttributes(item) {
            //alert(JSON.stringify(item))
            return item, {}
        },
        update_active_protein(val) {
            //alert(JSON.stringify(this.active_transcript.pdb_ids))
            //this.$store.dispatch("setActiveTranscript",this.active_transcript)

            //this.active_protein = this.active_transcript.pdb_ids[0]
            this.active_protein = val
            //alert(this.active_protein)
            this.$store.dispatch("setActiveProtein",this.active_protein)
            //alert(JSON.stringify(this.active_transcript))
            //alert(this.active_transcript.transcript_id)
            //this.loadProteinViewers()

            //this.format_protein_sequence(this.active_transcript.protein_sequence,
            //        this.$store.getters.getActiveBiomarker[key].UTA_Adapter_gene.prot_location
            //    )
        },
        update_active_transcript(val) {
            for (let key of Object.keys(this.$store.getters.getActiveBiomarker)) {
                const activeBiomarker = this.$store.getters.getActiveBiomarker
                //alert(key + JSON.stringify(Object.keys(activeBiomarker)))
                this.active_transcript=this.$store.getters.getActiveBiomarker[key].gencode_genomic.transcripts[val]
                this.$store.dispatch("setActiveTranscript",this.active_transcript)
                //alert(JSON.stringify(this.active_transcript))
                //alert(this.active_transcript.transcript_id)

                try {
                    //alert(JSON.stringify(this.active_transcript))
                    if ("pdb_ids" in this.active_transcript) {
                        if (this.active_transcript.pdb_ids.length > 0) {
                            this.active_protein = this.active_transcript.pdb_ids[0]
                            //this.loadProteinViewers()

                            /*this.format_protein_sequence(this.active_transcript.protein_sequence,
                                    this.$store.getters.getActiveBiomarker[key].UTA_Adapter_gene.prot_location,
                                    activeBiomarker[key]["UTA_Adapter_gene"]["var"]
                                )*/
                        }
                    }
                } catch(error) {
                    console.log(error)
                }
            }
        },
        getCAAtomCoordinates(data, resn, resi) {
            // Split the PDB data into lines
            var lines = data.split('\n');

            // Initialize variables to store the coordinates
            var x = 0;
            var y = 0;
            var z = 0;

            // Convert the input resi to a number
            var targetResi = parseInt(resi);

            // Iterate through each line to find the CA atom for the specified amino acid residue
            for (var i = 0; i < lines.length; i++) {
                var line = lines[i].trim();

                // Check if the line represents an atom entry (ATOM or HETATM)
                if ((line.startsWith('ATOM') || line.startsWith('HETATM')) && (line.substr(13, 4).trim() === 'CA')) {
                    // Extract amino acid residue information from the line
                    var lineResn = line.substr(17, 3).trim();
                    var lineResi = parseInt(line.substr(23, 4).trim());

                    // Check if the current atom matches the specified amino acid residue
                    if (lineResn === resn && lineResi === targetResi) {
                        console.log(line)
                        //alert(line)
                        // Extract x, y, and z coordinates
                        x = parseFloat(line.substr(31, 7).trim());
                        y = parseFloat(line.substr(39, 7).trim());
                        z = parseFloat(line.substr(47, 7).trim());

                        // Break out of the loop since we found the coordinates
                        break;
                    }
                }
            }

            // Return the coordinates as an object
            return { x: x, y: y, z: z };
        },
                Interpolate(start, end, steps, count) {
                    var s = start,
                        e = end,
                        final = s + (((e - s) / steps) * count);
                    return Math.floor(final);
                },

                Color(_r, _g, _b) {
                    var r, g, b;
                    var setColors = function(_r, _g, _b) {
                        r = _r;
                        g = _g;
                        b = _b;
                    };

                    setColors(_r, _g, _b);
                    this.getColors = function() {
                        var colors = {
                            r: r,
                            g: g,
                            b: b
                        };
                        return colors;
                    };
                },
        async loadProteinViewers() {
            // Init 3D protein view
            //var pdbids = this.$store.getters.activeTranscript.pdb_ids
            var pdbid = this.active_protein
            let pdb_data = ""
            let patho_data = ""

            let activeBiomarker = this.$store.getters.getActiveBiomarker[Object.keys(this.$store.getters.getActiveBiomarker)[0]]

            let refAAMapping = {
                "A": "ALA",
                "R": "ARG",
                "N": "ASN",
                "D": "ASP",
                "C": "CYS",
                "Q": "GLN",
                "E": "GLU",
                "G": "GLY",
                "H": "HIS",
                "I": "ILE",
                "L": "LEU",
                "K": "LYS",
                "M": "MET",
                "F": "PHE",
                "P": "PRO",
                "S": "SER",
                "T": "THR",
                "W": "TRP",
                "Y": "TYR",
                "V": "VAL",
                "U": "SEC",
                "O": "PYL",
                "B": "ASX",
                "Z": "GLX",
                "X": "XAA"
            }


            let resn_oneletter = activeBiomarker["UTA_Adapter_gene"]["ref"]
            let resn = refAAMapping[resn_oneletter]
            let resi = activeBiomarker["UTA_Adapter_gene"]["prot_location"]
            resi = resi.toString()
            //alert(resi)

                let url = this.$store.getters.getPathVariable('methods_generate_plot')

                // get PDB data
                let formData = new FormData();
                formData.append("plot", "pdb");
                //formData.append("variant_data", JSON.stringify(this.$store.getters.getActiveBiomarker))

                let activeBiomarkerQID = Object.keys(this.$store.getters.getActiveBiomarker)[0]
                //alert(JSON.stringify(this.$store.getters.getActiveBiomarker))
                let gene = this.$store.getters.getActiveBiomarker[activeBiomarkerQID]["UTA_Adapter"]["gene_name"]
                let variant_exchange = this.$store.getters.getActiveBiomarker[activeBiomarkerQID]["UTA_Adapter"]["variant_exchange"]
                let variant_data_form =  { [activeBiomarkerQID]: { "UTA_Adapter": {"gene_name": gene, "variant_exchange": variant_exchange }}}

                //alert(JSON.stringify(variant_data_form))

                variant_data_form = JSON.stringify( variant_data_form )
                formData.append("variant_data", variant_data_form)
                //alert(JSON.stringify(variant_data_form))

                formData.append("qid", Object.keys(this.$store.getters.getActiveBiomarker)[0])
                //alert(Object.keys(this.$store.getters.getActiveBiomarker)[0])
                //formData.append("width", 1200)
                //formData.append("height", 1000)

                await axios.post(url, formData, {
                    headers: {
                        "Content-Type": "text/html"
                    }
                }).then((response) => {
                    var response_data = response.data

                    try {
                        pdb_data = response_data[0].data.PDB_file_string
                        this.pdb_data = pdb_data
                        //alert(JSON.stringify(pdb_data))
                    } catch (error) {
                        console.log(error)
                        //alert(error)
                    }

                })

                pdbid="1"
                //alert(pdbid)

            if (pdbid!=undefined) {
                let colorAsSnake = function(atom) {
                    return atom.resi % 2 == 0 ? 'white' : 'green';
                }

                try {

                    if (this.$refs.viewerContainer0) {

                        var viewer = $3Dmol.createViewer(this.$refs.viewerContainer0);
                        var viewer4 =  $3Dmol.createViewer(this.$refs.viewerContainer4);


                        //var molecule = viewer.addModel(data, "pdb");
                        var molecule = viewer.addModel(pdb_data, "pdb");
                        var molecule14 = viewer4.addModel(pdb_data, "pdb");
                    }
                } catch (e) {
                    console.log(e)
                }

                    //var getPathoColor = d3.scaleLinear()
                    //    .domain( [0,10,20,30] )
                    //    .range( ["white", "green", "yellow", "red"] )
                    let patho_arr = []

                    let am_url = this.$store.getters.getPathVariable('methods_get_am_region_scores')
                    let chrom = activeBiomarker["UTA_Adapter_gene"]["chromosome"]
                    //alert(JSON.stringify(activeBiomarker["gencode_genomic"]["gene"]))
                    let pos_start = activeBiomarker["gencode_genomic"]["gene"][0][" start_pos"]
                    let pos_end = activeBiomarker["gencode_genomic"]["gene"][0][" end_pos"]
                    am_url = am_url + "?chrom=" + chrom + "&pos_start=" + pos_start + "&pos_end=" + pos_end


                //try {
                await axios.get(am_url, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }).then((response) => {
                    var response_data = response.data

                    try {
                        let gene_key = chrom + ":" + pos_start + "-" + pos_end
                        patho_data = response_data[gene_key]
                        //alert(JSON.stringify(patho_data))

                        //for (const [key, value] of Object.entries(patho_data)) {
                        //    alert(key + ":" + value)
                        //}
                    } catch (error) {
                        console.log(error)
                    }

                })
                //} catch (e) { console.error(e)}

                try {
                let prot_length = activeBiomarker["UTA_Adapter_protein_sequence"]["protein_sequence"].length
                for (let i = 0; i< prot_length; i++) {
                    if (String(i) in patho_data) {
                        //alert("pos found" + JSON.stringify(patho_data[String(i)]))
                        patho_arr.push(String(patho_data[String(i)]))
                    } else{
                        patho_arr.push(0.5)
                    }
                    //patho_arr.push(Math.random())
                }
                //alert(JSON.stringify(patho_arr))
                } catch(e) {
                    console.log(e)
                }

function Interpolate(start, end, steps, count) {
    var s = start,
        e = end,
        final = s + (((e - s) / steps) * count);
    return Math.floor(final);
}

function Color(_r, _g, _b) {
    var r, g, b;
    var setColors = function(_r, _g, _b) {
        r = _r;
        g = _g;
        b = _b;
    };

    setColors(_r, _g, _b);
    this.getColors = function() {
        var colors = {
            r: r,
            g: g,
            b: b
        };
        return colors;
    };
}

function perc2color(perc) {
	var r, g, b = 0;
	if(perc < 50) {
		//r = 255;
		b = 255
		r = Math.round(5.1 * perc);
		g = Math.round(5.1 * perc);
	}
	else {
		//g = 255;
		r = 255
		g = Math.round(510 - 5.10 * perc);
		b = Math.round(510 - 5.10 * perc);
	}
	//var h = r * 0x10000 + g * 0x100 + b * 0x1;
	var h = r * 0x10000 + g*0x100 + b * 0x1;
	//alert(h+","+r+","+g+","+b+","+0x100)

	var hex = function(x) {
        x = x.toString(16);
        return (x.length == 1) ? '0' + x : x;
    };
    //var r = Math.ceil(parseInt(color1.substring(0,2), 16) * ratio + parseInt(color2.substring(0,2), 16) * (1-ratio));
    //var g = Math.ceil(parseInt(color1.substring(2,4), 16) * ratio + parseInt(color2.substring(2,4), 16) * (1-ratio));
    //var b = Math.ceil(parseInt(color1.substring(4,6), 16) * ratio + parseInt(color2.substring(4,6), 16) * (1-ratio));


	//var h = r* 0x10000 + g*0x1 + b * 0x100
	return '#' + ('000000' + h.toString(16)).slice(-6);
}

                //alert(res_no)
                //for (let i=0; i<)
                let red = new Color(255, 0, 0)
                let white = new Color(255, 255, 255)
                let green = new Color(0, 0, 255)
                let start = green
                let end = white;

                var startColors = start.getColors(),
                    endColors = end.getColors();

                //var mutated_patho = "grey"


                var colorByPathogenicity = function(atom) {
                    //var c = getPathoColor( atom.b )
                    //return d3.rgb(c).hex()
                    //alert(JSON.stringify(atom.resi))

                    let patho = patho_arr[atom.resi]
                    //alert(patho)

                    let color = "#ffffff"
                    if (patho > 0.5) {
                        color = "#ab1828"
                    } else if (patho < 0.5) {
                        color = "#1861ab"
                    }

                    patho = patho*100
                    var r = Interpolate(startColors.r, endColors.r, 50, patho);
                    var g = Interpolate(startColors.g, endColors.g, 50, patho);
                    var b = Interpolate(startColors.b, endColors.b, 50, patho);
                    //let c = "rgb(" + r + "," + g + "," + b + ")"
                    let c = perc2color(patho)
                    //alert(c)

                    //alert(resi + ":: " + atom.resi)

                    return c
                }

                var colorMutatedPosition = function(atom) {
                    let patho = patho_arr[atom.resi]
                    //alert(patho)
                    let color = "#ffffff"
                    if (patho > 0.5) {
                        color = "#ab1828"
                    } else if (patho < 0.5) {
                        color = "#1861ab"
                    }

                    patho = patho*100
                    var r = Interpolate(startColors.r, endColors.r, 50, patho);
                    var g = Interpolate(startColors.g, endColors.g, 50, patho);
                    var b = Interpolate(startColors.b, endColors.b, 50, patho);
                    //let c = "rgb(" + r + "," + g + "," + b + ")"
                    let c = perc2color(patho)
                    //alert(c)

                    //alert(resi + ":: " + atom.resi)
                    if (parseInt(atom.resi) == parseInt(resi)) {
                        //alert(resi + ":" + patho + ":" + c)
                        return c
                    }
                    return "grey"
                }

                let colorCAAtom = function(atom) {

                    //alert(atom.atom + "::" + atom.resn + ";;" + resn + ":" + resi)
                    //return atom.resi % 2 == 0 ? 'white' : 'green';
                    //if ((atom.resi == resi) && (resn.localeCompare(atom.resn) == 0)) {
                    if (atom.atom.localeCompare("CA") == 0) {
                        return 'yellow'
                    } else {
                        return 'red'
                    }
                  };

                let colorCAAtom1 = function(atom) {
                    //alert(atom.atom + "::" + atom.resn + ";;" + resn + ":" + resi)
                    //return atom.resi % 2 == 0 ? 'white' : 'green';
                    //if ((atom.resi == resi) && (resn.localeCompare(atom.resn) == 0)) {
                    if (atom.atom.localeCompare("CA") == 0) {
                        return 'yellow'
                    } else {
                        return 'blue'
                    }
                  };

                try {

                //molecule.setStyle({}, {cartoon: {color: "spectrum"}});
                molecule.setStyle({}, {cartoon: {colorfunc: colorByPathogenicity }});
                molecule14.setStyle({}, {cartoon: {colorfunc: colorByPathogenicity }});

                var coordinates = this.getCAAtomCoordinates(pdb_data, resn, resi);
                //alert("coord"+JSON.stringify(coordinates))

                // Add mutated position
                //alert(resn + ":" + resi)
                //molecule.setStyle({resn: resn, resi: resi}, {stick: {color: "red", thickness: 1.0}});
                //molecule.setStyle({resn: resn, resi: resi}, {stick: {colorfunc: colorCAAtom, thickness: 1.0}});
                //molecule.setStyle({resi: resi}, {stick: {colorfunc: colorCAAtom, thickness: 1.0}});
                //alert(this.mutated_patho)
                molecule.setStyle({resi: resi}, {stick: {colorfunc: colorMutatedPosition, thickness: 1.0}});
                molecule14.setStyle({resi: resi}, {stick: {colorfunc: colorMutatedPosition, thickness: 1.0}});

                /* TP53 CA distance explanation (TP53:R282W) */

                /*var selection = {
                        resi: [282, 275, 325, 319]
                    };
                    viewer.addSurface($3Dmol.SurfaceType.VDW, {color: '#e4fdff',opacity: 1.0}, {
                        not: selection // Exclude the marked position
                    });
                    viewer4.addSurface($3Dmol.SurfaceType.VDW, {color: '#e4fdff',opacity: 1.0}, {
                        not: selection // Exclude the marked position
                    });*/

                /*molecule.setStyle({resi: 275}, {stick: {colorfunc: colorCAAtom1, thickness: 1.0}});
                molecule.setStyle({resi: 325}, {stick: {colorfunc: colorCAAtom1, thickness: 1.0}});
                molecule.setStyle({resi: 319}, {stick: {colorfunc: colorCAAtom1, thickness: 1.0}});
                molecule.setStyle({resi: 282}, {stick: {colorfunc: colorCAAtom, thickness: 1.0}});*/

                /* EGFR sample (EGFR:G796D) */

                /*molecule.setStyle({resi: resi}, {stick: {color: '#ff1446', thickness: 1.0}});
                molecule14.setStyle({resi: resi}, {stick: {color: '#ff1446', thickness: 1.0}});

                molecule.setStyle({resi: 719}, {stick: {color: '#ffbd14', thickness: 1.0}});
                molecule14.setStyle({resi: 719}, {stick: {color: '#ffbd14', thickness: 1.0}});

                molecule.setStyle({resi: 785}, {stick: {color: '#ffbd14', thickness: 1.0}});
                molecule14.setStyle({resi: 785}, {stick: {color: '#ffbd14', thickness: 1.0}});

                var selection = {
                        resi: [resi, 785, 719]
                    };
                    viewer.addSurface($3Dmol.SurfaceType.VDW, {color: '#fffadb',opacity: 1.0}, {
                        not: selection // Exclude the marked position
                    });
                    viewer4.addSurface($3Dmol.SurfaceType.VDW, {color: '#fff5dd',opacity: 1.0}, {
                        not: selection // Exclude the marked position
                    });

                    /*viewer.addSurface($3Dmol.SurfaceType.VDW, {
                        opacity: 0.6,  // Low opacity for the selected range
                        color: '#ff1446'
                    }, selection);
                    viewer4.addSurface($3Dmol.SurfaceType.VDW, {
                        opacity: 0.6,  // Low opacity for the selected range
                        color: '#ff1446'
                    }, selection);

                                        viewer.addSurface($3Dmol.SurfaceType.VDW, {
                        opacity: 0.6,  // Low opacity for the selected range
                        color: '#ffbd14'
                    }, {
                        resi: [719]
                    });
                    viewer4.addSurface($3Dmol.SurfaceType.VDW, {
                        opacity: 0.6,  // Low opacity for the selected range
                        color: '#ffbd14'
                    }, {
                        resi: [719]
                    });

                                        viewer.addSurface($3Dmol.SurfaceType.VDW, {
                        opacity: 0.6,  // Low opacity for the selected range
                        color: '#ffbd14'
                    }, {
                        resi: [785]
                    });
                    viewer4.addSurface($3Dmol.SurfaceType.VDW, {
                        opacity: 0.6,  // Low opacity for the selected range
                        color: '#ffbd14'
                    }, {
                        resi: [785]
                    });*/

                } catch(error){
                    console.log(error)
                }



                try {
                //viewer.addLabel(resn+resi, {position: coordinates, fontColor: "black", fontSize: 20, backgroundColor: "red", backgroundOpacity: 0.5});

                // configure viewer style and animation
                //viewer.addLabel(resn+resi, {position: {x:2.6, y:0.75, z:0.35}, fontColor: "black", fontSize: 20, backgroundColor: "red", backgroundOpacity: 0.5});
                viewer.setBackgroundColor('#ffffff');
                viewer4.setBackgroundColor('#ffffff');
                //viewer.addSurface($3Dmol.VDW, {'opacity': 0.4})
                //viewer4.addSurface($3Dmol.SAS, {'opacity': 0.4})
                //viewer.addSurface($3Dmol.SAS, {'opacity': 1.0})
                //viewer.addSurface($3Dmol.SurfaceType.SAS, {map:{prop:'partialCharge',scheme:new $3Dmol.Gradient.RWB(-.05,.05)}, opacity:1.0},{});
                } catch(error) {
                    console.log(error)
                }

                //viewer.zoomTo({resn: resn, resi: resi});
                try {
                    if (this.$refs.viewerContainer0) {
                        viewer.zoomTo({resi:resi})
                        viewer4.zoomTo({resi:resi})
                        //alert(resi)
                        viewer.render();
                        viewer4.render()
                        viewer.zoom(0.3, 1000);
                        viewer4.zoom(0.3, 1000);
                    }
                } catch (error) {
                    if (error.name === 'NS_ERROR_NOT_AVAILABLE') { alert(error.name) }
                        console.log(error)
                }


                // Get Openfold PDB prediction data
                /*url = this.$store.getters.getPathVariable('methods_generate_plot')
                formData = new FormData();
                formData.append("plot", "pdb_openfold_wt");
                //formData.append("variant_data", JSON.stringify({"pdb":pdb_data,"protein":activeBiomarker["UTA_Adapter"]["gene_name"]}))
                formData.append("variant_data", JSON.stringify(this.$store.getters.getActiveBiomarker))
                //formData.append("variant_data", JSON.stringify(pdb_data))
                //formData.append("qid", activeBiomarker["UTA_Adapter"]["gene_name"])
                formData.append("qid", Object.keys(this.$store.getters.getActiveBiomarker)[0])
                let pdb_data_openfold_wt = ""
                //} catch (e) { console.error(e)}
                //try {
                await axios.post(url, formData, {
                    headers: {
                        "Content-Type": "text/html"
                    }
                }).then((response) => {
                    var response_data = response.data
                    try {
                        pdb_data_openfold_wt = response_data[0].data.PDB_file_string
                        //alert(pdb_data_openfold_wt)
                    } catch (error) {
                        console.log(error)
                    }
                })*/


                // Get Openfold PDB mutated prediction data
                /*url = this.$store.getters.getPathVariable('methods_generate_plot')
                formData = new FormData();
                formData.append("plot", "pdb_openfold_mutated");
                //formData.append("variant_data", JSON.stringify({"pdb":pdb_data,"protein":activeBiomarker["UTA_Adapter"]["gene_name"]}))
                formData.append("variant_data", JSON.stringify(this.$store.getters.getActiveBiomarker))
                //formData.append("variant_data", JSON.stringify(pdb_data))
                //formData.append("qid", activeBiomarker["UTA_Adapter"]["gene_name"] + ":" + activeBiomarker["UTA_Adapter"]["variant_exchange"])
                formData.append("qid", Object.keys(this.$store.getters.getActiveBiomarker)[0])
                let pdb_data_openfold_mutated = ""
                //} catch (e) { console.error(e)}
                //try {
                await axios.post(url, formData, {
                    headers: {
                        "Content-Type": "text/html"
                    }
                }).then((response) => {
                    var response_data = response.data
                    try {
                        pdb_data_openfold_mutated = response_data[0].data.PDB_file_string
                    } catch (error) {
                        console.log(error)
                    }
                })

                // Load Openfold predictions
                    let config2 = { backgroundColor: '#ffffff' }
                    try {
                        var viewer2 = $3Dmol.createViewer(this.$refs.viewerContainer2, config2);
                        var viewer6 = $3Dmol.createViewer(this.$refs.viewerContainer6, config2);

                        var molecule2 = viewer2.addModel(pdb_data_openfold_wt, "pdb");
                        var molecule2alt = viewer2.addModel(pdb_data_openfold_mutated, "pdb")
                        var molecule26 = viewer6.addModel(pdb_data_openfold_wt, "pdb");
                        var molecule26alt = viewer6.addModel(pdb_data_openfold_mutated, "pdb")

                        molecule2.setStyle({}, {cartoon: {color: "#f5f5f5" }});
                        molecule26.setStyle({}, {cartoon: {color: "#f5f5f5" }});
                        molecule2alt.setStyle({}, {cartoon: {color: "#327cb7" }});
                        molecule26alt.setStyle({}, {cartoon: {color: "#327cb7" }});
                        //alert(resn + ":" + resi)
                        molecule2.setStyle({resi: resi}, {stick: {color: "blue", thickness: 1.0}});
                        molecule26.setStyle({resi: resi}, {stick: {color: "blue", thickness: 1.0}});

                        molecule2alt.setStyle({resi: resi}, {stick: {color: "red", thickness: 1.0}});
                        molecule26alt.setStyle({resi: resi}, {stick: {color: "red", thickness: 1.0}});

                        // configure viewer style and animation
                        viewer2.setBackgroundColor('#ffffff');
                        viewer6.setBackgroundColor('#ffffff');
                    } catch (error) {
                        console.log(error)
                    }

                    try {
                        viewer2.zoomTo({resi: resi});
                        viewer6.zoomTo({resi: resi});

                        viewer2.render();
                        viewer6.render();

                        if (viewer2) {
                            viewer2.zoom(0.3, 1000);
                        }
                        viewer6.zoom(0.3, 1000);
                    } catch (error) {
                        console.log(error)
                    }
                    */

                // Get PDB binding site prediction data
                url = this.$store.getters.getPathVariable('methods_generate_plot')
                formData = new FormData();
                formData.append("plot", "pdb_scannet");
                //formData.append("variant_data", JSON.stringify({Object.keys(this.$store.getters.getActiveBiomarker)[0]: { "UTA_Adapter": activeBiomarker["UTA_Adapter"]["gene_name"]}}))
                //formData.append("variant_data", JSON.stringify(pdb_data))
                formData.append("qid", activeBiomarker["UTA_Adapter"]["gene_name"])

                let pdb_data_scannet = ""
                //} catch (e) { console.error(e)}

                try {
                await axios.post(url, formData, {
                    headers: {
                        "Content-Type": "text/html"
                    }
                }).then((response) => {
                    var response_data = response.data

                    try {
                        pdb_data_scannet = response_data["pdb"]
                        //alert(JSON.stringify(pdb_data_scannet))
                        this.pdb_bs_data = pdb_data_scannet
                    } catch (error) {
                        console.log(error)
                    }

                })

                } catch(e) {
                    console.log(e)
                }

                // Render binding site prediction
                try {
                    if (this.$refs.viewerContainer1) {
                        var viewer1 = $3Dmol.createViewer(this.$refs.viewerContainer1);
                        var viewer5 = $3Dmol.createViewer(this.$refs.viewerContainer5);
                        //var molecule = viewer.addModel(pdb_data_scannet, "pdb");
                        let config = { backgroundColor: '#ffffff' }
                        var molecule1 = viewer1.addModel(pdb_data_scannet, "pdb");
                        var molecule15 = viewer5.addModel(pdb_data_scannet, "pdb");

                        var getBfactorColour = function(bfactor) {
                            return
                        }

                        var colorByBFactor = function(atom) {
                            var c = getBfactorColour( atom.b );
                            alert(c)
                            //console.log( "atom:", atom.hetflag, atom.b, c, d3.rgb( c ).hex() );
                            return d3.rgb( c ).hex();
                        };
                    }
                } catch (error) {
                        console.log(error)
                }

                    //molecule1.setStyle({}, {cartoon: {colorfunc: colorByBFactor}});

                try {
                    if (this.$refs.viewerContainer1) {
                        var colorGradient = new $3Dmol.Gradient.RWB(0,0.7);
                        // Color atoms based on B-factor values
                        //viewer1.setStyle({}, {cartoon: "none"});
                        //var gradient = new $3Dmol.Gradient.RWB($3Dmol.getPropertyRange(viewer1.selectedAtoms(),'b'));

                        var gradient = new $3Dmol.Gradient.RWB(0,0.7);
                        //var selection = {resi: resi};
                        var selection = {
                            resi: [resi - 1, resi, resi + 1]
                        };
                        viewer1.addSurface($3Dmol.SurfaceType.VDW, {colorscheme: {prop: 'b', gradient: gradient},opacity: 1.0}, {
                            not: selection // Exclude the marked position
                        });
                        viewer5.addSurface($3Dmol.SurfaceType.VDW, {colorscheme: {prop: 'b', gradient: gradient},opacity: 1.0}, {
                            not: selection // Exclude the marked position
                        });

                        viewer1.addSurface($3Dmol.SurfaceType.VDW, {
                            opacity: 0.6,  // Low opacity for the selected range
                            color: 'white',
                            colorscheme: {prop: 'b', gradient: gradient}
                        }, selection);
                        viewer5.addSurface($3Dmol.SurfaceType.VDW, {
                            opacity: 0.6,  // Low opacity for the selected range
                            color: 'white',
                            colorscheme: {prop: 'b', gradient: gradient}
                        }, selection);
                    }
                } catch (error) {
                    console.log(error)
                }

                try {
                    if (this.$refs.viewerContainer1) {
                        //molecule1.setStyle({}, {cartoon: {colorfunc: colorByPathogenicity }});
                        molecule1.setStyle({}, {cartoon: {colorscheme: {prop: 'bfactor'} }});
                        viewer1.setStyle({}, {cartoon: {colorscheme: {prop: 'bfactor', gradient: 'roygb', min: 0, max: 0.7}}});
                        //viewer1.setStyle({}, {surface: {colorscheme: {prop: 'bfactor', gradient: 'roygb', min: 0, max: 0.7}}})
                        //viewer1.addLabel(resn+resi, {position: coordinates, fontColor: "black", fontSize: 20, backgroundColor: "red", backgroundOpacity: 0.5});
                        //viewer5.addLabel(resn+resi, {position: coordinates, fontColor: "black", fontSize: 20, backgroundColor: "red", backgroundOpacity: 0.5});

                        //viewer.setStyle({resi: "*", b: [0, 0.7]}, {cartoon: "none", colorfunc: function(atom) {
                        //    return colorGradient.valueToHex(atom.b);
                        //}});

                        molecule1.setStyle({resi: resi}, {stick: {color: "red", thickness: 2.0}});
                        molecule15.setStyle({resi: resi}, {stick: {color: "red", thickness: 2.0}});
                        // configure viewer style and animation
                        viewer1.setBackgroundColor('#ffffff');
                        viewer5.setBackgroundColor('#ffffff');
                        //viewer1.zoomTo({resn: resn, resi: resi});


                            viewer1.zoomTo({resi:resi})
                            viewer5.zoomTo({resi:resi})

                            viewer1.render();
                            viewer5.render();

                            viewer1.zoom(0.3, 1000);
                            viewer5.zoom(0.3, 1000);
                    }
                } catch (error) {
                    console.log(error)
                }

            } else {
                try {
                    if (this.$refs.viewerContainer1) {
                        var viewer = $3Dmol.createViewer(this.$refs.viewerContainer0);
                        var viewer1 = $3Dmol.createViewer(this.$refs.viewerContainer1);
                        let config2 = { backgroundColor: '#ffffff' }
                        var viewer2 = $3Dmol.createViewer(this.$refs.viewerContainer2, config2);
                        var viewer4 = $3Dmol.createViewer(this.$refs.viewerContainer4, config2);
                        var viewer5 = $3Dmol.createViewer(this.$refs.viewerContainer5, config2);
                        var viewer6 = $3Dmol.createViewer(this.$refs.viewerContainer6, config2);
                    }
                } catch(error) {console.log(error)}
            }
        }

    },
    created: async function () {



    },
    mounted: async function () {
        this.isLoading = true
        this.$store.dispatch("setIsLoading", true)
        await active_variants.loadActiveBiomarkerSNV(this.$route.params.id)
        this.isLoading = false


        await this.loadProteinData()
        let activeBiomarker = this.$store.getters.getActiveBiomarker
        this.pid = Object.keys(activeBiomarker)[0]
        activeBiomarker = activeBiomarker[Object.keys(activeBiomarker)[0]]
        if (!("gencode_genomic" in activeBiomarker)) {
            //alert("get gencode")
            var request_id = this.$store.getters.requestID
            await variant_annotation.analyzeVariants("gencode", "1", "pub", null, request_id = request_id)
            await active_variants.loadActiveBiomarkerSNV(this.$route.params.id)
            activeBiomarker = activeBiomarker[Object.keys(activeBiomarker)[0]]
            //alert(JSON.stringify(activeBiomarker))
        }

        this.defineColumns()
        /*if ("gencode_genomic" in activeBiomarker) {
            await this.update_active_transcript(activeBiomarker.gencode_genomic.MANE_Select_transcript)
        }else {alert("no gencode")}
        alert(JSON.stringify(activeBiomarker))
        if ("UTA_Adapter" in activeBiomarker) {
            await this.update_active_transcript(activeBiomarker.gencode_genomic.MANE_Select_transcript)
        }else {alert("no gencode")}*/

        await this.loadProteinViewers()
        //alert(activeBiomarker.UTA_Adapter_gene.prot_location)
        /*this.format_protein_sequence(this.active_transcript.protein_sequence,
                                    activeBiomarker.UTA_Adapter_gene.prot_location,
                                    activeBiomarker["UTA_Adapter_gene"]["var"]
                                )*/


        this.$store.dispatch("setIsLoading", false)
    },
    computed: {
        ...mapGetters([
            'activeTranscript'
        ])
    },
    watch: {
        activeTranscript: {
            handler(newTranscript) {
                //alert("new transcript: ",newTranscript)
                //this.loadProteinViewers()
            }
        }
    },
}
</script>
<style>
.v-card-title {
    font-size:16px;font-weight:300;padding:0;margin:0;margin-left:10px;
}
v-table hd + td { border-left:1px solid #dddddd; }
.pseq-link {

}

.pseq-link:hover {
    cursor: pointer;
}

.table-title {
    font-size: var(--font-600);
    font-family: var(--default-font);
    text-align: left;
    font-weight: 300;
}

.loading-spinner {
  margin-top: 20px;
  text-align:center;
}

.spinner {
  border: 8px solid #f3f3f3;
  border-top: 8px solid #3498db;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

</style>
